/*
	CSS
*/
require('../../shared/css/bootstrap.min.css');
require('../../shared/css/font-awesome.min.css');
require('../../Yummy/css/dripicons.min.css');
require('../../shared/css/animate.css');
require('../../Yummy/css/hover/hover-min.css');
require('../../Yummy/less/styles.less');
require('../../Yummy/css/modal-lightbox/ekko-lightbox.min.css');
require('../../Yummy/css/overlay-effects/overlay-effects.css');
require('../../shared/css/blocks.css');

/*
	scripts (as conventional globals)
*/
require("script!../../shared/js/jquery.min.js");
require("script!../../shared/js/jquery-ui.min.js");
require("script!../../shared/js/bootstrap.min.js");
require("script!../../Yummy/js/vendors/metismenu/metisMenu.min.js");
require("script!../../Yummy/js/vendors/nicescroll/jquery.nicescroll.min.js");
require("script!../../Yummy/js/vendors/modal-lightbox/ekko-lightbox.min.js");
require('script!../../shared/js/maps.js');
require('script!../../shared/js/parallax.js');
require("script!../../Yummy/js/scripts.js");



//////////////////
// WEBPACK FOOTER
// ./assets/entrypoints/professional/_shared.js
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18